import { Col, Modal, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import ShareWithPublic from "./ShareWithPublic";
import ShareWithTeacher from "./ShareWithTeacher";
import { ApiConnector } from "../../axios/apiClient";
import {
	ADD_SHARED_PLAYLIST_WITH_TEACHER,
	FETCH_SHARED_ID_BY_PLAYLIST_ID,
} from "../../axios/AllBaseUrl";
import CustomToast from "../../utlis/toast/CustomToast";
import FlagLocalhost from "../../Localhost/FlagLocalhost";
/**
 * ShareIcon Component
 * ------------------
 * Handles sharing a playlist with teachers via a modal.
 *
 * Responsibilities:
 * 1. Display share modal
 * 2. Fetch already-shared teachers for a playlist
 * 3. Allow selecting teachers to share with
 * 4. Submit share mapping to backend
 * 5. Reset and cleanup state on close
 */
const ShareIcon = ({
	isModalOpen,
	handleCancel,
	url,
	handleOk,
	copied,
	setCopied,
	playlistId,
}) => {
	const localData = FlagLocalhost();

	/**
	 * Stores selected teacher user IDs
	 */
	const [selectedUsers, setSelectedUsers] = useState<number[]>([]);

	/**
	 * Search input text for teacher selection
	 */
	const [searchText, setSearchText] = useState<string>("");

	/**
	 * Ensures ShareWithTeacher renders only after API response
	 */
	const [checkApi, setCheckApi] = useState<boolean>(false);

	/**
	 * Maps selected teachers to the playlist
	 * Calls backend API to save sharing configuration
	 */
	const mappedPlaylist = async () => {
		try {
			if (selectedUsers?.length > 0) {
				let res = await ApiConnector(
					"post",
					`${ADD_SHARED_PLAYLIST_WITH_TEACHER}`,
					{
						playlist_id: playlistId,
						user_ids: selectedUsers,
						school_id: Number(localData?.school_id),
						academic_year_id: Number(localData?.academic_year_id),
					},
				);
				if (res?.data?.ok) {
					CustomToast("success", res?.data?.data?.message);
					setSelectedUsers([]);
					setSearchText("");
					handleOk();
				}
			} else {
				CustomToast("warning", "Please select teacher");
			}
		} catch (error) {
			console.log(error);
		}
	};
	/**
	 * Close modal and reset state
	 */
	const cancelModal = () => {
		setSelectedUsers([]);
		setSearchText("");
		handleCancel();
	};
	/**
	 * Fetch already shared teachers for this playlist
	 * Used to preselect users when modal opens
	 */
	const fetchSelectedUsers = async () => {
		try {
			let res = await ApiConnector(
				"post",
				`${FETCH_SHARED_ID_BY_PLAYLIST_ID}`,
				{
					playlist_id: playlistId,
					school_id: Number(localData?.school_id),
				},
			);
			if (res?.data?.ok) {
				// console.log("res?.data", res?.data?.data?.share_user_ids);
				setCheckApi(true);
				setSelectedUsers(res?.data?.data?.share_user_ids || []);
			} else {
				setSelectedUsers([]);
			}
		} catch (error) {}
	};
	// console.log("selectedUsers", selectedUsers);
	/**
	 * Fetch shared users when modal opens
	 */
	useEffect(() => {
		if (isModalOpen && playlistId) {
			fetchSelectedUsers();
		}
	}, [isModalOpen]);
	return (
		<Modal open={isModalOpen} onCancel={cancelModal} onOk={mappedPlaylist}>
			{/* <ShareWithPublic url={url} setCopied={setCopied} copied={copied} /> */}
			{checkApi && (
				<ShareWithTeacher
					selectedUsers={selectedUsers}
					setSelectedUsers={setSelectedUsers}
					searchText={searchText}
					setSearchText={setSearchText}
				/>
			)}
		</Modal>
	);
};

export default ShareIcon;
